import { defineStore } from 'pinia'
import { api, resetCsrf } from '../api'

export const useAuthStore = defineStore('auth', {
  state: () => ({ user: null, ready: false }),
  getters: { isAdmin: (s) => s.user?.role === 'admin', isLoggedIn: (s) => !!s.user },
  actions: {
    async load() { try { const r = await api.get('auth/me.php'); this.user = r.user || null } catch (_) { this.user = null } finally { this.ready = true } },
    async login(email, password) { const r = await api.post('auth/login.php', { email, password }); this.user = r.user; resetCsrf(); return r.user },
    async register(payload) { const r = await api.post('auth/register.php', payload); this.user = r.user; resetCsrf(); return r.user },
    async logout() { try { await api.post('auth/logout.php', {}) } finally { this.user = null; resetCsrf() } }
  }
})
